import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { WalletContext } from "../../../../../CustomHelper/Helper";
import Audition from "../../.././../../Assets/Images/walletImg/AuditionPoint.png";
import clubPoint from "../../.././../../Assets/Images/walletImg/clubPoint.png";
import Club from "../../.././../../Assets/Icon/icon/Club.png";
import Greetings from "../../.././../../Assets/Images/walletImg/Greetings.png";
import LearningPoint from "../../.././../../Assets/Images/walletImg/LearningPoint.png";
import liveChat from "../../.././../../Assets/Images/walletImg/LiveChatPoint.png";
import Meetup from "../../.././../../Assets/Images/walletImg/Meetup.png";
import QApoint from "../../.././../../Assets/Images/walletImg/QA.png";
import iconSta from "../../.././../../Assets/Icon/icon-sta.png";
import Mukut from "../../.././../../Assets/Icon/icon/Layer.png";
import Love from "../../.././../../Assets/Icon/icon/love3.png";
import silverPoint from "../../.././../../Assets/Images/walletImg/silverPoint.png";
import "../../../../CSS/Wallet/Wallet.css";
import "./Content.css";

const Content = (props) => {
  // const [userWallet, setGetUserWallet] = useState();
  // const [userWalletId, setGetUserWalletId] = useState();
  // const [lastUserWalletHistory, setLastUserWalletHistory] = useState();

  const { userWallet, setGetUserWallet } = useContext(WalletContext);
  const { userWalletId, setGetUserWalletId } = useContext(WalletContext);
  const { lastUserWalletHistory, setLastUserWalletHistory } =
    useContext(WalletContext);

  const { checkRealTime, setCheckRealTime } = useContext(WalletContext);

  useEffect(() => {
    axios.get(`/api/user/wallet/details`).then((res) => {
      if (res.status === 200) {
        setGetUserWallet(res.data?.userWallet);
        setGetUserWalletId(res.data?.userWalletId);
      }
    });
    axios.get(`/api/user/wallet/history`).then((res) => {
      if (res.status === 200) {
        setLastUserWalletHistory(res.data?.userLastWalletHistory);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/user/wallet/details`).then((res) => {
      if (res.status === 200) {
        setGetUserWallet(res.data?.userWallet);
        setGetUserWalletId(res.data?.userWalletId);
      }
    });
    axios.get(`/api/user/wallet/history`).then((res) => {
      if (res.status === 200) {
        setLastUserWalletHistory(res.data?.userLastWalletHistory);
      }
    });
  }, [checkRealTime]);

  return (
    <>
      <div className="walletContainer">
        <div className="walletChildren ">
          <div className="row m-3 p-2">
            <div className="col-md-6">
              <center>
                <div className="balanceTxt my-2">Love React ❤️‍🔥</div>
              </center>
              <div className="backGroundBg my-1">
                ❤️&nbsp;
                {userWallet?.love_points ? userWallet?.love_points : 0}
              </div>
            </div>
            <div className="col-md-6">
              <div>
                <div>
                  <center>
                    <div className="balanceTxt my-2">
                      Your Status <img src={iconSta} alt="" />
                    </div>
                  </center>
                  <div className="backGroundBg d-flex justify-content-center my-1">
                    <img src={silverPoint} alt="" />
                    &nbsp;
                    {userWallet
                      ? userWallet?.type
                      : "No"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row my-3">
            <div className="col-md-6 mx-auto">
              <div>
                <div>
                  <center>
                    <div className="balanceTxtAuto">Club Point</div>
                  </center>
                  <div className="backGroundBg d-flex justify-content-center mb-1">
                    <img src={clubPoint} className="mx-2" alt="" />
                    {userWallet?.club_points ? userWallet?.club_points : 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row main-club my-3 justify-content-center align-items-center">
          <div className="col-sm-6 col-md-6 col-lg-4 mb-4  Club ">
            <div className=" club-card p-2">
              <div className="text-center">
                <img src={liveChat} alt="" />
                <p className="fw-bold club-txt pt-2">Live Chat</p>
                <h3 className="points">
                  {userWallet?.live_chats ? userWallet?.live_chats : 0}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 mb-4  Club">
            <div className=" club-card p-2">
              <div className="text-center">
                <img src={Meetup} alt="" />
                <p className="fw-bold club-txt pt-2">Meetup</p>
                <h3 className="points">
                  {userWallet?.meetup ? userWallet?.meetup : 0}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 mb-4  Club">
            <div className=" club-card p-2">
              <div className="text-center">
                <img src={Audition} alt="" />
                <p className="fw-bold club-txt pt-2">Auditions</p>
                <h3 className="points">
                  {userWallet?.auditions ? userWallet?.auditions : 0}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 mb-4  Club ">
            <div className=" club-card p-2">
              <div className="text-center">
                <img src={LearningPoint} alt="" />
                <p className="fw-bold club-txt pt-2">Learning Session</p>
                <h3 className="points">
                  {userWallet?.learning_session
                    ? userWallet?.learning_session
                    : 0}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 mb-4  Club">
            <div className=" club-card p-2">
              <div className="text-center">
                <img src={Greetings} alt="" />
                <p className="fw-bold club-txt pt-2">Greetings</p>
                <h3 className="points">
                  {userWallet?.greetings ? userWallet?.greetings : 0}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 mb-4  Club">
            <div className=" club-card p-2">
              <div className="text-center">
                <img src={QApoint} alt="" />
                <p className="fw-bold club-txt pt-2">Q & A</p>
                <h3 className="points">
                  {userWallet?.qna ? userWallet?.qna : 0}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Content;
